import { render } from "./psiGoods.vue?vue&type=template&id=2a1ffc1c"
import script from "./psiGoods.vue?vue&type=script&lang=jsx"
export * from "./psiGoods.vue?vue&type=script&lang=jsx"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__